export const bigIntMax = (...arguments_: readonly bigint[]): bigint =>
  arguments_.reduce((m, c) => (c > m ? c : m))

export const bigIntMin = (...arguments_: readonly bigint[]): bigint =>
  arguments_.reduce((m, c) => (c < m ? c : m))
